import { AuthInformation, User } from '../models/api'

export function getUser(): User | undefined {
  const userString = localStorage.getItem(keys.user)

  if (!userString) {
    return
  }

  return JSON.parse(userString)
}

export function setUser(user: User): void {
  localStorage.setItem(keys.user, JSON.stringify(user))
}

export function getAuthInformation(): AuthInformation | undefined {
  const authInformation = localStorage.getItem(keys.authInformation)

  if (!authInformation) {
    return
  }

  return JSON.parse(authInformation)
}

export function setAuthInformation(authInformation: AuthInformation): void {
  localStorage.setItem(keys.authInformation, JSON.stringify(authInformation))
}

export function logout(): void {
  localStorage.removeItem(keys.user)
  localStorage.removeItem(keys.authInformation)
  localStorage.removeItem(keys.showDelinquentNoticeBanner)
}

const keys = {
  authInformation: 'authInformation',
  user: 'user',
  showDelinquentNoticeBanner: 'showDelinquentNoticeBanner',
} as const
